import React from "react";

import { Modal } from "../Modal";
import { ModalActions } from "../ModalActions";

/**
 * Props for the Confirmation component.
 */
export interface ConfirmationProps {
  /**
   * Title of the modal
   */
  title?: React.ReactNode;
  /**
   * Function to execute when user confirms action
   */
  onConfirm: () => void;
  /**
   * Function to execute when user cancels action
   */
  onCancel: () => void;
  /**
   * Displays the confirmation
   */
  isOpen?: boolean;
  /**
   * Confirm button text.
   */
  confirmText: string;
  /**
   * Cancel button text.
   */
  cancelText: string;
  /**
   * Custom class name
   */
  className?: string;
  /**
   * Loading state of the modal actions
   */
  loading?: boolean;
  /**
   * The size of the modal
   */
  size?: "small" | "medium_deprecated" | "medium" | "large" | "full";
}

/**
 * A confirmation modal.
 */
export function Confirmation({
  children,
  title,
  onConfirm,
  onCancel,
  isOpen,
  confirmText,
  cancelText,
  className,
  loading,
  size = "small",
}: React.PropsWithChildren<ConfirmationProps>) {
  return (
    <Modal
      size={size}
      className={className}
      isOpen={isOpen}
      modalTitle={title}
      onClose={onCancel}
    >
      {children}
      <ModalActions
        mainAction={{
          text: confirmText,
          title: confirmText,
          onClick: onConfirm,
          loading,
        }}
        cancelAction={{
          text: cancelText,
          title: cancelText,
          onClick: onCancel,
          loading,
        }}
      />
    </Modal>
  );
}
